import { IconProps } from '@repo/core/global-data/dataInterface.data';


const FileIcon = ({ width = '48', height = '48', className = '' }: IconProps) => {
    return (
        <span>
            <svg
                width={width}
                height={height}
                className={className}
                viewBox="0 0 149 148"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* First Path */}
                <path
                    d="M56 109.458C55.3833 109.458 54.8283 109.335 54.2117 109.089C52.485 108.41 51.375 106.683 51.375 104.833V67.8335C51.375 65.3052 53.4717 63.2085 56 63.2085C58.5283 63.2085 60.625 65.3052 60.625 67.8335V93.6718L65.065 89.2318C66.8533 87.4435 69.8133 87.4435 71.6017 89.2318C73.39 91.0202 73.39 93.9802 71.6017 95.7685L59.2683 108.102C58.405 108.965 57.1717 109.458 56 109.458Z"
                    fill="currentColor"
                />
                {/* Second Path */}
                <path
                    d="M56 109.459C54.8284 109.459 53.6567 109.027 52.7317 108.102L40.3984 95.7685C38.61 93.9802 38.61 91.0202 40.3984 89.2319C42.1867 87.4435 45.1467 87.4435 46.935 89.2319L59.2684 101.565C61.0567 103.354 61.0567 106.314 59.2684 108.102C58.3434 109.027 57.1717 109.459 56 109.459Z"
                    fill="currentColor"
                />
                {/* Third Path */}
                <path
                    d="M93.0002 140.292H56.0002C22.5152 140.292 8.2085 125.985 8.2085 92.5002V55.5002C8.2085 22.0152 22.5152 7.7085 56.0002 7.7085H86.8335C89.3618 7.7085 91.4585 9.80516 91.4585 12.3335C91.4585 14.8618 89.3618 16.9585 86.8335 16.9585H56.0002C27.5718 16.9585 17.4585 27.0718 17.4585 55.5002V92.5002C17.4585 120.929 27.5718 131.042 56.0002 131.042H93.0002C121.429 131.042 131.542 120.929 131.542 92.5002V61.6668C131.542 59.1385 133.639 57.0418 136.167 57.0418C138.695 57.0418 140.792 59.1385 140.792 61.6668V92.5002C140.792 125.985 126.485 140.292 93.0002 140.292Z"
                    fill="currentColor"
                />
                {/* Fourth Path */}
                <path
                    d="M136.167 66.2915H111.5C90.4102 66.2915 82.2085 58.0898 82.2085 36.9998V12.3332C82.2085 10.4832 83.3185 8.75652 85.0452 8.07818C86.7718 7.33818 88.7452 7.76985 90.1018 9.06485L139.435 58.3982C140.73 59.6932 141.162 61.7282 140.422 63.4548C139.682 65.1815 138.017 66.2915 136.167 66.2915ZM91.4585 23.4948V36.9998C91.4585 52.9098 95.5902 57.0415 111.5 57.0415H125.005L91.4585 23.4948Z"
                    fill="currentColor"
                />
            </svg>
        </span>
    );
};

export default FileIcon;
